import { render, staticRenderFns } from "./classFile2023.vue?vue&type=template&id=b7283a46"
import script from "./classFile2023.vue?vue&type=script&lang=js"
export * from "./classFile2023.vue?vue&type=script&lang=js"
import style0 from "./classFile2023.vue?vue&type=style&index=0&id=b7283a46&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports